﻿var emailCallout;
var validator;

/*-----
   When the DOM is done loading
-----*/
$(document).ready(function () {

	emailCallout = ui.callout('#emailCallout', {
		content: '#emailCalloutContent'
	});

	validator = ui.validator(document.getElementById('registerForm'), {
		fields: {
			firstName: {
				errorLocation: 'below', pattern: function (patternData) {
					return new RegExp(patternData.field.getAttribute('data-regex')).test(patternData.value);
				}, required: true, when: 'submit'
			},
			lastName: {
				errorLocation: 'below', pattern: function (patternData) {
					return new RegExp(patternData.field.getAttribute('data-regex')).test(patternData.value);
				}, required: true, when: 'submit'
			},
			email: { errorLocation: 'below', pattern: 'email', required: true, when: 'submit' },
			password: { pattern: 'password', required: true, when: 'submit' },
			terms: { errorLocation: 'below', required: true }
		},
		onSubmit: function (validatorData) { // validatorData: { element, valid, fields }

			if (validatorData.valid) {
				$('#continueButton').addClass('disabled loading');
				return true;
			}

			return false;
		},
		submitButton: document.getElementById('continueButton')
	});

	$('#passwordToggle').passwordToggle();
	$('#passwordToggle320').passwordToggle();
});